import React from 'react';

interface SelectIconProps {
  className?: string;
  size?: number;
}

export const SelectIcon: React.FC<SelectIconProps> = ({ 
  className = "w-5 h-5", 
  size = 20 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Arrow with natural curve */}
      <path
        d="M5 12l7-7 7 7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Subtle arrow shaft */}
      <path
        d="M12 5v14"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.8"
      />
      {/* Selection box hint */}
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="2"
        stroke="currentColor"
        strokeWidth="1"
        fill="none"
        opacity="0.3"
        strokeDasharray="2 2"
      />
    </svg>
  );
};

export default SelectIcon;
